module.exports = __webpack_public_path__ + "img/fitness.65ebb809.svg";